var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"py-5"},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-row',[_c('b-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('h2',{staticClass:"font-weight-bold"},[_vm._v("Ops!")]),_c('p',{staticClass:"mb-0"},[_vm._v("Página não encontrada ou não existente!")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }